<div class="container-fluid">

  <!--    <div *ngFor="let dashboard of dashboards; let i = index;">-->
  <!--        <div *ngIf="i%2===0" class="row">-->
  <!--            <div *ngIf="dashboard.type==='MULTI'" class="chart-width right-separator">-->
  <!--                <app-multi-axis-chart [title]="dashboard.name" [dashboardConfigs]="dashboard.dashboardConfigs" [footer]="dashboard.footer" [description]="dashboard.description" [index]="i"></app-multi-axis-chart>-->
<!--            </div>-->
<!--            <div *ngIf="dashboard.type==='STACKED'" class="chart-width right-separator">-->
<!--                <app-stacked-chart [title]="dashboard.name" [dashboardConfigs]="dashboard.dashboardConfigs" [footer]="dashboard.footer" [description]="dashboard.description" [index]="i"></app-stacked-chart>-->
<!--            </div>-->
<!--            <div *ngIf="dashboard.type==='BAR'" class="chart-width right-separator">-->
<!--                <app-bar-chart [title]="dashboard.name" [dashboardConfigs]="dashboard.dashboardConfigs" [footer]="dashboard.footer" [description]="dashboard.description" [index]="i"></app-bar-chart>-->
<!--            </div>-->
<!--            <div *ngIf="dashboard.type==='PIE'" class="chart-width right-separator">-->
<!--                <app-pie-chart [title]="dashboard.name" [dashboardConfigs]="dashboard.dashboardConfigs" [footer]="dashboard.footer" [description]="dashboard.description" [index]="i"></app-pie-chart>-->
<!--            </div>-->


<!--            <div *ngIf="i + 1 < dashboards.length && dashboards[i + 1].type==='MULTI'" class="chart-width">-->
<!--                <app-multi-axis-chart [title]="dashboards[i+1].name" [dashboardConfigs]="dashboards[i+1].dashboardConfigs" [footer]="dashboards[i+1].footer" [description]="dashboards[i+1].description" [index]="i+1"></app-multi-axis-chart>-->
<!--            </div>-->
<!--            <div *ngIf="i + 1 < dashboards.length && dashboards[i + 1].type==='STACKED'" class="chart-width">-->
<!--                <app-stacked-chart [title]="dashboards[i+1].name" [dashboardConfigs]="dashboards[i+1].dashboardConfigs" [footer]="dashboards[i+1].footer" [description]="dashboards[i+1].description" [index]="i+1"></app-stacked-chart>-->
<!--            </div>-->
<!--            <div *ngIf="i + 1 < dashboards.length && dashboards[i + 1].type==='BAR'" class="chart-width">-->
<!--                <app-bar-chart [title]="dashboards[i+1].name" [dashboardConfigs]="dashboards[i+1].dashboardConfigs" [footer]="dashboards[i+1].footer" [description]="dashboards[i+1].description" [index]="i+1"></app-bar-chart>-->
<!--            </div>-->
<!--            <div *ngIf="i + 1 < dashboards.length && dashboards[i + 1].type==='PIE'" class="chart-width">-->
<!--                <app-pie-chart [title]="dashboards[i+1].name" [dashboardConfigs]="dashboards[i+1].dashboardConfigs" [footer]="dashboards[i+1].footer" [description]="dashboards[i+1].description" [index]="i+1"></app-pie-chart>-->
<!--            </div>-->


<!--        </div>-->
<!--    </div>-->
<!-- Navigation Controls -->
<div class="dashboard-nav">
  <div class="d-flex justify-content-between align-items-center">
    <div class="my-dashboard-select">
      <ng-select [clearable]="false" [appendTo]="'body'"
        name="dashboard"
        [items]="dashboards"
        bindLabel="name"
        [placeholder]="'select dashboard'"
        [virtualScroll]="true" [searchable]="false"
        (change)="goTo($event)"
        [ngModel]="dashboards[currentIndex]">
      </ng-select>
    </div>

    <div class="carousel-controls">
      <button class="btn btn-primary" (click)="prev()" [disabled]="currentIndex === 0">&#8592;</button>
      <span>{{ currentIndex + 1 }} / {{ dashboards.length }}</span>
      <button class="btn btn-primary" (click)="next()" [disabled]="currentIndex === dashboards.length - 1">
        &#8594;
      </button>
    </div>
  </div>
  <hr/>
</div>

<!-- Single Dashboard Display -->
@if (currentDashboard; as dashboard) {
  <div class="dashboard-container mt-3">
    @switch (dashboard.type) {
      @case ('MULTI') {
        <app-multi-axis-chart
          [title]="dashboard.name"
          [dashboardConfigs]="dashboard.dashboardConfigs"
          [footer]="dashboard.footer"
          [description]="dashboard.description"
          [index]="currentIndex">
        </app-multi-axis-chart>
      }
      @case ('STACKED') {
        <app-stacked-chart
          [title]="dashboard.name"
          [dashboardConfigs]="dashboard.dashboardConfigs"
          [footer]="dashboard.footer"
          [description]="dashboard.description"
          [index]="currentIndex">
        </app-stacked-chart>
      }
      @case ('BAR') {
        <app-bar-chart
          [title]="dashboard.name"
          [dashboardConfigs]="dashboard.dashboardConfigs"
          [footer]="dashboard.footer"
          [description]="dashboard.description"
          [index]="currentIndex">
        </app-bar-chart>
      }
      @case ('PIE') {
        <app-pie-chart
          [title]="dashboard.name"
          [dashboardConfigs]="dashboard.dashboardConfigs"
          [footer]="dashboard.footer"
          [description]="dashboard.description"
          [index]="currentIndex">
        </app-pie-chart>
      }
    }
  </div>
}

</div>